/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as errors from "../../../../errors/index.js";
import * as core from "../../../../core/index.js";

export class MethodNotAllowedError extends errors.LangfuseAPIError {
  constructor(body?: unknown, rawResponse?: core.RawResponse) {
    super({
      message: "MethodNotAllowedError",
      statusCode: 405,
      body: body,
      rawResponse: rawResponse,
    });
    Object.setPrototypeOf(this, MethodNotAllowedError.prototype);
  }
}
